module.exports = __webpack_public_path__ + "static/media/settings-gray.39cf48f6.svg";